import React from 'react';
import { NextBestActionsButton, NextBestActionsButtonProps } from './NextBestActionsButton';
import { useServicesContext } from '@oneaudi/vtp-shared';
import { ContentService } from '@oneaudi/content-service';
import { NextBestActionsContainer, NextBestActionsInnerContainer } from './NextBestActions.styles';

interface NextBestActionsProps {
  vehicleId: string;
}
export const NextBestActions: React.FC<NextBestActionsProps> = ({ vehicleId }) => {
  const servicesContext = useServicesContext();
  const audiContentService = servicesContext.getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const nbas = audiContentService.getContent()?.fields?.nbas;
  return nbas ? (
    <NextBestActionsContainer>
      <NextBestActionsInnerContainer>
        {nbas.map((nba: NextBestActionsButtonProps['type']) => {
          return (
            <NextBestActionsButton
              key={`next-best-action-${nba}`}
              vehicleId={vehicleId}
              type={nba}
            />
          );
        })}
      </NextBestActionsInnerContainer>
    </NextBestActionsContainer>
  ) : null;
};
